import React from "react"
import { Box, FormControl, FormHelperText, FormLabel, Skeleton, Typography } from "@mui/material"

// ── SVG Silhouettes — from actual board SVGs ───────────────────────────

const P = { stroke: "currentColor", fill: "none", strokeWidth: 4, strokeLinecap: "round", strokeLinejoin: "round" }

// Nose shapes — cropped to top ~40% of board outline
const NoseSvgs = {
  Round: () => (
    <svg viewBox="30 0 245 400" width="40" height="60">
      <path d="M155,18.1c0,0-45.4-1.1-62.6,38.6S55.8,201.1,55.8,429.5c0,169.3,1.1,223.2,15.4,320.5c20,135.9,51.7,144.3,51.7,144.3h31.2h0.3h29.2c0,0,30.7-8.4,49.9-144.3c13.8-97.3,14.9-151.2,14.9-320.5c0-228.4-19-333-35.6-372.7c-16.6-39.8-58.5-38.6-58.5-38.6" {...P} />
    </svg>
  ),
  Performance: () => (
    <svg viewBox="20 0 290 420" width="40" height="60">
      <path d="M100.7,914.5c0,0-55.8-176.5-55.8-412.8c0-381,120.005-481.915,120.005-481.915s120.01,98.786,120.01,479.577c0,268.7-58.8,415.2-58.8,415.2s-6.4,23.4-43.8,23.4s-43.7,0-43.7,0S106.4,934.1,100.7,914.5z" {...P} />
    </svg>
  ),
  Hybrid: () => (
    <svg viewBox="0 0 330 400" width="40" height="60">
      <path d="M90.146,864.644c0,0-63.404-93.002-68.249-467.143c-4.479-345.974,143-380.115,143-380.115S310.9,51.511,307.9,397.5c-3.002,345.99-67.404,467.476-67.404,467.476s-19.557,47.604-48.754,47.604s-52-0.193-52-0.193S118.742,918.311,90.146,864.644z" {...P} />
    </svg>
  ),
}

// Tail shapes — cropped to bottom ~40% of board outline
const TailSvgs = {
  Diamond: () => (
    <svg viewBox="30 550 245 380" width="40" height="55">
      <path d="M155.2,907l-34.3-10.9c0,0-34.4-8.4-56.1-144.5c-15.5-97.4-16.7-151.4-16.7-320.9C48.1,202.1,69,97.4,87.7,57.6c18.8-39.7,64.9-38.7,64.9-38.7s47.8-1,65.8,38.8c18,39.8,38.5,144.5,38.5,373.1c0,169.5-1.2,223.4-16.1,320.9c-20.9,136.1-54.1,144.5-54.1,144.5L155.2,907z" {...P} />
    </svg>
  ),
  Squash: () => (
    <svg viewBox="20 580 290 400" width="40" height="55">
      <path d="M100.7,914.5c0,0-55.8-176.5-55.8-412.8c0-381,120.005-481.915,120.005-481.915s120.01,98.786,120.01,479.577c0,268.7-58.8,415.2-58.8,415.2s-6.4,23.4-43.8,23.4s-43.7,0-43.7,0S106.4,934.1,100.7,914.5z" {...P} />
    </svg>
  ),
  Round: () => (
    <svg viewBox="30 550 245 380" width="40" height="55">
      <path d="M120.915,886.42c0,0-42.537-35.113-56.073-144.25c-15.51-97.267-16.703-151.148-16.703-320.389c0-228.321,20.934-332.883,39.588-372.571c18.764-39.688,64.859-38.688,64.859-38.688s47.83-1,65.835,38.787c18.004,39.787,38.503,144.25,38.503,372.571c0,169.242-1.191,223.123-16.052,320.391c-17.244,116.489-54.121,144.249-54.121,144.249S155.189,920.204,120.915,886.42z" {...P} />
    </svg>
  ),
  Square: () => (
    <svg viewBox="30 550 245 370" width="40" height="55">
      <path d="M155,18.1c0,0-45.4-1.1-62.6,38.6S55.8,201.1,55.8,429.5c0,169.3,1.1,223.2,15.4,320.5c20,135.9,51.7,144.3,51.7,144.3h31.2h0.3h29.2c0,0,30.7-8.4,49.9-144.3c13.8-97.3,14.9-151.2,14.9-320.5c0-228.4-19-333-35.6-372.7c-16.6-39.8-58.5-38.6-58.5-38.6" {...P} />
    </svg>
  ),
  Pin: () => (
    <svg viewBox="30 550 245 380" width="40" height="55">
      <path d="M152.585,903.5c0,0-66.595-32.409-88.287-165.988c-15.51-95.638-16.703-148.617-16.703-315.027c0-224.498,20.934-327.311,39.588-366.333c18.765-39.021,64.859-38.038,64.859-38.038s47.83-0.983,65.835,38.137c18.004,39.12,38.502,141.834,38.502,366.332c0,166.408-1.19,219.386-16.051,315.026C219.397,871.188,152.585,903.5,152.585,903.5z" {...P} />
    </svg>
  ),
  Swallow: () => (
    <svg viewBox="20 580 290 400" width="40" height="55">
      <path d="M109.746,914.464c0,0-64.81-176.452-64.81-412.846c0-381.031,120.005-481.915,120.005-481.915s120.01,98.786,120.01,479.577c0,268.733-71.766,415.222-71.766,415.222l-48.125-21.274L109.746,914.464z" {...P} />
    </svg>
  ),
  Crescent: () => (
    <svg viewBox="0 600 239 400" width="40" height="55">
      <path d="M87.83,969.848c0,0-34.382-9.108-56.073-156.507C16.247,707.809,15.054,649.35,15.054,465.727c0-247.722,20.935-361.17,39.588-404.229c18.766-43.059,64.859-41.974,64.859-41.974s47.83-1.085,65.835,42.083c18.004,43.167,38.503,156.507,38.503,404.229c0,183.623-1.19,242.083-16.052,347.614c-20.933,147.396-54.121,156.508-54.121,156.508S119.934,946.502,87.83,969.848z" {...P} />
    </svg>
  ),
}

// Fin setups — actual board outline + actual fin box paths from PerformanceSquashSvg
const F = { stroke: "currentColor", fill: "none", strokeLinecap: "round", strokeLinejoin: "round" }
const BOARD_OUTLINE = "M100.7,914.5c0,0-55.8-176.5-55.8-412.8c0-381,120.005-481.915,120.005-481.915s120.01,98.786,120.01,479.577c0,268.7-58.8,415.2-58.8,415.2s-6.4,23.4-43.8,23.4s-43.7,0-43.7,0S106.4,934.1,100.7,914.5z"
const FIN_CENTER_LONG = "M171.816,863.752c0,2.233-1.672,4.109-3.58,4.109h-5.487c-2.028,0-3.58-1.878-3.58-4.109V753.181c0-2.229,1.67-4.106,3.58-4.106h5.487c2.029,0,3.58,1.879,3.58,4.106V863.752z"
const FIN_CENTER_SHORT = "M171.58,879.979c0,2.231-1.672,4.105-3.58,4.105h-5.131c-2.029,0-3.58-1.876-3.58-4.105v-46.482c0-2.229,1.67-4.107,3.58-4.107H168c2.027,0,3.58,1.878,3.58,4.107V879.979z"
const FIN_LEFT = "M94.858,775.854c-0.238,2.232-2.027,3.875-4.056,3.521l-5.013-0.703c-2.028-0.234-3.339-2.349-3.101-4.576l5.248-46.013c0.24-2.229,2.029-3.874,4.057-3.523l5.011,0.703c2.028,0.238,3.341,2.351,3.102,4.577L94.858,775.854z"
const FIN_RIGHT = "M249.374,773.861c0.356,2.23-1.075,4.343-2.983,4.692l-5.014,0.823c-2.027,0.352-3.816-1.174-4.175-3.405l-6.204-45.777c-0.357-2.23,1.072-4.344,2.984-4.695l5.011-0.82c1.909-0.354,3.817,1.175,4.176,3.402L249.374,773.861z"
const FIN_REAR_LEFT = "M119.414,842.761c0,2.233-1.986,4.109-4.252,4.109h-6.093c-2.412,0-4.252-1.879-4.252-4.109v-46.361c0-2.232,1.984-4.109,4.252-4.109h6.093c2.409,0,4.252,1.877,4.252,4.109V842.761z"
const FIN_REAR_RIGHT = "M230.941,841.588c0,2.229-1.981,4.105-4.25,4.105h-6.096c-2.406,0-4.252-1.878-4.252-4.105v-46.365c0-2.229,1.985-4.104,4.252-4.104h6.096c2.408,0,4.25,1.877,4.25,4.104V841.588z"

const FinTile = ({ fins }) => (
  <svg viewBox="20 700 290 290" width="50" height="55">
    <path d={BOARD_OUTLINE} {...F} strokeWidth={3} />
    <g fill="currentColor" fillOpacity={0.4} stroke="currentColor" strokeWidth={1}>
      {fins.map((d, i) => <path key={i} d={d} />)}
    </g>
  </svg>
)

const FinSvgs = {
  Single: () => <FinTile fins={[FIN_CENTER_LONG]} />,
  "2+1": () => <FinTile fins={[FIN_CENTER_LONG, FIN_LEFT, FIN_RIGHT]} />,
  Twin: () => <FinTile fins={[FIN_LEFT, FIN_RIGHT]} />,
  Thruster: () => <FinTile fins={[FIN_CENTER_SHORT, FIN_LEFT, FIN_RIGHT]} />,
  Quad: () => <FinTile fins={[FIN_LEFT, FIN_RIGHT, FIN_REAR_LEFT, FIN_REAR_RIGHT]} />,
  "4+1": () => <FinTile fins={[FIN_CENTER_LONG, FIN_LEFT, FIN_RIGHT, FIN_REAR_LEFT, FIN_REAR_RIGHT]} />,
  "5-Fin": () => <FinTile fins={[FIN_CENTER_SHORT, FIN_LEFT, FIN_RIGHT, FIN_REAR_LEFT, FIN_REAR_RIGHT]} />,
}

// Rocker — full surfboard side profile with thickness
const RockerSvgs = {
  "Low Rocker": () => (
    <svg viewBox="0 0 100 30" width="65" height="22">
      {/* Bottom curve — flat */}
      <path d="M6 20 Q15 22, 50 22 Q85 22, 94 19" stroke="currentColor" fill="none" strokeWidth={1.2} strokeLinecap="round" />
      {/* Deck curve */}
      <path d="M6 18 Q15 19, 50 19.5 Q85 19, 94 17" stroke="currentColor" fill="none" strokeWidth={1.2} strokeLinecap="round" />
      {/* Nose tip */}
      <path d="M6 18 Q4 19, 6 20" stroke="currentColor" fill="none" strokeWidth={1} />
      {/* Tail tip */}
      <path d="M94 17 Q96 18, 94 19" stroke="currentColor" fill="none" strokeWidth={1} />
    </svg>
  ),
  "Natural Rocker": () => (
    <svg viewBox="0 0 100 30" width="65" height="22">
      <path d="M8 16 Q20 22, 50 23 Q80 22, 93 16" stroke="currentColor" fill="none" strokeWidth={1.2} strokeLinecap="round" />
      <path d="M8 14 Q20 19, 50 20.5 Q80 19, 93 14" stroke="currentColor" fill="none" strokeWidth={1.2} strokeLinecap="round" />
      <path d="M8 14 Q6 15, 8 16" stroke="currentColor" fill="none" strokeWidth={1} />
      <path d="M93 14 Q95 15, 93 16" stroke="currentColor" fill="none" strokeWidth={1} />
    </svg>
  ),
  "High Rocker": () => (
    <svg viewBox="0 0 100 30" width="65" height="22">
      <path d="M10 12 Q25 24, 50 25 Q75 24, 92 10" stroke="currentColor" fill="none" strokeWidth={1.2} strokeLinecap="round" />
      <path d="M10 10 Q25 21, 50 22.5 Q75 21, 92 8" stroke="currentColor" fill="none" strokeWidth={1.2} strokeLinecap="round" />
      <path d="M10 10 Q8 11, 10 12" stroke="currentColor" fill="none" strokeWidth={1} />
      <path d="M92 8 Q94 9, 92 10" stroke="currentColor" fill="none" strokeWidth={1} />
    </svg>
  ),
}

export const SVG_MAPS = {
  nose: NoseSvgs,
  tail: TailSvgs,
  fin: FinSvgs,
  rocker: RockerSvgs,
}

// ── Tile Selector Component ─────────────────────────────────────────────

const OptionTileSelector = ({ title, option, options, updateOptions, orderData, isStaff, svgMap }) => {
  if (!option) return <Skeleton />

  const disabled = orderData?.locked && !isStaff

  return (
    <Box my={1}>
      <FormControl fullWidth>
        <FormLabel>
          <Typography variant="caption">{title}</Typography>
        </FormLabel>
        <Box sx={{ display: "flex", flexWrap: "wrap", justifyContent: "center", gap: 1, mt: 0.5 }}>
          {options.map((opt) => {
            const selected = option?.value === opt.value
            const SvgIcon = svgMap?.[opt.value]
            return (
              <Box
                key={opt.value}
                onClick={() => { if (!disabled) updateOptions([opt]) }}
                sx={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  px: 1.5,
                  py: 1,
                  borderRadius: 1.5,
                  cursor: disabled ? "default" : "pointer",
                  border: selected ? "1.5px solid #c8b99a" : "1.5px solid transparent",
                  bgcolor: selected ? "rgba(200,185,154,0.1)" : "rgba(255,255,255,0.04)",
                  color: selected ? "#c8b99a" : "rgba(255,255,255,0.45)",
                  transition: "all 0.15s",
                  minWidth: 62,
                  "&:hover": disabled ? {} : {
                    border: "1.5px solid rgba(255,255,255,0.2)",
                    color: "#fff",
                  },
                }}
              >
                {SvgIcon && <SvgIcon />}
                <Typography sx={{
                  fontFamily: "'Josefin Sans', sans-serif",
                  fontSize: "0.55rem",
                  textTransform: "uppercase",
                  letterSpacing: "0.06em",
                  mt: 0.5,
                  textAlign: "center",
                  lineHeight: 1.2,
                }}>
                  {opt.value}
                </Typography>
              </Box>
            )
          })}
        </Box>
        {option?.help_text && (
          <FormHelperText sx={{ textAlign: "center" }}>{option.help_text.replace(/\bthird\b/gi, "quarter")}</FormHelperText>
        )}
      </FormControl>
    </Box>
  )
}

export default OptionTileSelector
